const MESSAGES = {
    INVALID_POST: 'Invalid Post Code',
    CONNECTION_ERROR: 'Connection Error'
  }
  
  module.exports = {
    MESSAGES
  }